import {
  Box, TableContainer, Table, TableHead, Tooltip, Typography,
  TableRow, TableCell, TableBody, TextField, IconButton, Grid
} from "@mui/material";
import SelectionBox from './selectionBox';
import Badge from './badge';
import { useEffect, useState, useCallback } from "react";
import CustomButton from 'components/Common/Button';
import { PRIMARY_BUTTON, DISABLED_BUTTON } from 'themes/theme';
import Snackbar from "components/Common/SnackBar";
import { fetchContactInfo, saveContactInfo, fetchStateContactInfo } from 'store/actions/correctYourDataActions';
import { useSelector, useDispatch } from 'react-redux';
import findLabel from './findLabel';
import ThreeDotsLoadingSpinner from 'components/Common/LoadingSpinner/threeDots';
import moment from 'moment';
import RadioButton from './radio';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeftLong } from '@fortawesome/free-solid-svg-icons';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import findTooltipContent from "./findTooltipContent";
import eventBus from "../../utils/eventBus"
import SecretaryState from "./SecretaryState";
import ZendeskLink from 'components/Common/ZendeskLink'

const ContactInformation = ({ onDataChange }) => {
  const dispatch = useDispatch()
  const claimedBusiness = useSelector(state => state.apiResponseReducers.dashboardInfo.business_list)
  const contactData = useSelector(state => state.correctYourDataReducer.contactInformation)
  const stateContactInfo = useSelector(state => state.correctYourDataReducer.stateContactInfo)
  const [saveDisable, setDisable] = useState(true)
  const [open, setOpen] = useState(false)
  const [snackData, setSnackData] = useState({
    isOpen: false,
    type: 'success',
    message: '',
  })
  const sx = {
    textBox: {
      '& .MuiInputBase-root': {
        caretColor: '#0A78CD',
        backgroundColor: '#fff !important',
      },
      '.MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline': {
        border: '1px solid #d3d3df',
      },
      '.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
        border: '1px solid #d3d3df',
      },
      '.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
        border: '1px solid #0A78CD !important',
      },
    },
    buttonPlacement: {
      marginTop: '30px',
      display: 'flex',
      justifyContent: 'end',
    },
    header: {
      color: '#25245f',
    },
    content: {
      color: '#66668f',
      marginTop: '10px',
      marginBottom: '10px',
    },
    arrow: {
      color: 'color.blue',
    },
    tooltip: {
      backgroundColor: 'color.blue',
    },
  }
  const saveCallback = data => {
    setSnackData(data)
    setDisable(true)
  }
  useEffect(() => {
    fetchContactInfo(dispatch, claimedBusiness[0].mkz_business_id)
    fetchStateContactInfo(dispatch, claimedBusiness[0].mkz_business_id)
  }, [dispatch, claimedBusiness])

  const saveContactInformation = useCallback(() => {
    const data = {
      ...contactData,
      businessId: claimedBusiness[0].mkz_business_id,
    }
    setDisable(true)
    saveContactInfo(dispatch, data, res => saveCallback(res))
    onDataChange(false)
  }, [claimedBusiness, dispatch, contactData, onDataChange])

  useEffect(() => {
    eventBus.on('cyd-tab-change', saveContactInformation)
    return function () {
      eventBus.off('cyd-tab-change', saveContactInformation)
    }
  }, [saveContactInformation])

  const handleContaInfo = (data, type) => {
    onDataChange(true)
    setDisable(false)
    const updatedData = contactData[type].map(row => {
      if (row.label === data.label) {
        return data
      } else {
        return row
      }
    })
    dispatch({
      type: 'UPDATECONTACTINFO',
      payload: {
        ...contactData,
        [type]: updatedData,
      },
    })
    dispatch({
      type: 'UPDATESTATECONTACTINFO',
      payload: {
        ...stateContactInfo,
        // stateCode: updatedData[1].userEnteredInformation
      },
    })
  }

  return (
    <>
      {contactData.contactInfo.length ? (
        <Box>
          <Grid container>
            <SecretaryState stateContactInfo={stateContactInfo} tab="contact" />
            <Grid item xs={1.5} sx={sx.buttonPlacement}>
              <Box>
                <CustomButton onClick={saveContactInformation} type={saveDisable ? DISABLED_BUTTON : PRIMARY_BUTTON}>
                  Update
                </CustomButton>
              </Box>
            </Grid>
          </Grid>
          <Box className="markaazCards">
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>EXISTING INFORMATION</TableCell>
                    <TableCell align="center">
                      <Box color="#00B596">Correct</Box>
                    </TableCell>
                    <TableCell align="center">
                      <Box color="#D14343">Incorrect</Box>
                    </TableCell>
                    <TableCell align="left">UPDATED INFORMATION</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {contactData.contactInfo.map(val => {
                    return (
                      <TableRow
                        key={val.label}
                        sx={{
                          'td, th': { border: 0 },
                          background: val.isCorrect === true ? '#F6FCFA' : val.isCorrect === false ? '#FDF6F6' : '#fff',
                        }}
                      >
                        <TableCell component="th" scope="row">
                          <Box>
                            <Box color="#0A78CD" fontSize="12px" fontWeight={400}>
                              {findLabel(val.label)}
                            </Box>
                            <Box
                              marginTop="5px"
                              fontSize="16px"
                              fontWeight={400}
                              color={val.publicInformation ? '#66668F' : '#BDBDCE'}
                            >
                              {val.publicInformation ? val.publicInformation : 'No data found'}
                            </Box>
                          </Box>
                        </TableCell>
                        <SelectionBox
                          data={val}
                          TooltipContent={findTooltipContent(val.label)}
                          onDataChange={changedData => handleContaInfo(changedData, 'contactInfo')}
                        />
                        <TableCell align="center">
                          {val.isCorrect !== null && <Badge type={val.isCorrect === true ? 'success' : 'error'} />}
                        </TableCell>
                        <TableCell align="left">
                          {val.updatedOn && (
                            <Box>
                              Updated on <br />
                              {moment(val.updatedOn).format('MM/DD/YYYY')}
                            </Box>
                          )}
                        </TableCell>
                      </TableRow>
                    )
                  })}
                  {
                    <TableRow
                      sx={{
                        'td, th': { border: 0 },
                        background:
                          contactData.addressContactInfo[3].isCorrect === true
                            ? '#F6FCFA'
                            : contactData.addressContactInfo[3].isCorrect === false
                            ? '#FDF6F6'
                            : '#fff',
                      }}
                    >
                      <TableCell component="th" scope="row">
                        <Box display="flex" gap="20px">
                          <Box>
                            <Box color="#0A78CD" fontSize="12px" fontWeight={400}>
                              City
                            </Box>
                            <Box
                              marginTop="5px"
                              fontSize="16px"
                              fontWeight={400}
                              color={contactData.addressContactInfo[0].publicInformation ? '#66668F' : '#BDBDCE'}
                            >
                              {contactData.addressContactInfo[0].publicInformation
                                ? contactData.addressContactInfo[0].publicInformation
                                : 'No data found'}
                            </Box>
                          </Box>
                          <Box>
                            <Box color="#0A78CD" fontSize="12px" fontWeight={400}>
                              State
                            </Box>
                            <Box
                              marginTop="5px"
                              fontSize="16px"
                              fontWeight={400}
                              color={contactData.addressContactInfo[1].publicInformation ? '#66668F' : '#BDBDCE'}
                            >
                              {contactData.addressContactInfo[1].publicInformation
                                ? contactData.addressContactInfo[1].publicInformation
                                : 'No data found'}
                            </Box>
                          </Box>
                          <Box>
                            <Box color="#0A78CD" fontSize="12px" fontWeight={400}>
                              Zip Code
                            </Box>
                            <Box
                              marginTop="5px"
                              fontSize="16px"
                              fontWeight={400}
                              color={contactData.addressContactInfo[2].publicInformation ? '#66668F' : '#BDBDCE'}
                            >
                              {contactData.addressContactInfo[2].publicInformation
                                ? contactData.addressContactInfo[2].publicInformation
                                : 'No data found'}
                            </Box>
                          </Box>
                        </Box>
                      </TableCell>
                      <TableCell align="right">
                        <Box display="flex" justifyContent="center">
                          <RadioButton
                            onChange={() =>
                              handleContaInfo(
                                {
                                  ...contactData.addressContactInfo[3],
                                  isDataChanged: true,
                                  isCorrect: true,
                                },
                                'addressContactInfo',
                              )
                            }
                            checked={
                              contactData.addressContactInfo[3].isCorrect === null
                                ? false
                                : contactData.addressContactInfo[3].isCorrect
                            }
                            type="success"
                          />
                        </Box>
                      </TableCell>
                      <TableCell align="right">
                        <Box display="flex" justifyContent="center">
                          <RadioButton
                            onChange={() =>
                              handleContaInfo(
                                {
                                  ...contactData.addressContactInfo[3],
                                  isDataChanged: true,
                                  isCorrect: false,
                                },
                                'addressContactInfo',
                              )
                            }
                            checked={
                              contactData.addressContactInfo[3].isCorrect === null
                                ? false
                                : !contactData.addressContactInfo[3].isCorrect
                            }
                            type="error"
                          />
                        </Box>
                      </TableCell>
                      <TableCell component="th" scope="row">
                        {contactData.addressContactInfo[3].isCorrect === null ? (
                          <Box display="flex" alignItems="center" gap="10px">
                            <Box>
                              <FontAwesomeIcon fontSize="16px" className="font-weight-bold" icon={faArrowLeftLong} />
                            </Box>
                            <Box>Choose one</Box>
                          </Box>
                        ) : contactData.addressContactInfo[3].isCorrect ? (
                          <Box display="flex" gap="20px">
                            <Box>
                              <Box color="#0A78CD" fontSize="12px" fontWeight={400}>
                                City
                              </Box>
                              <Box marginTop="5px" fontSize="16px" fontWeight={400} color="#66668F">
                                {contactData.addressContactInfo[0].publicInformation
                                  ? contactData.addressContactInfo[0].publicInformation
                                  : 'No data found'}
                                {/* {data.userEnteredInformation || data.publicInformation || 'No data found'} */}
                              </Box>
                            </Box>
                            <Box>
                              <Box color="#0A78CD" fontSize="12px" fontWeight={400}>
                                State
                              </Box>
                              <Box marginTop="5px" fontSize="16px" fontWeight={400} color="#66668F">
                                {contactData.addressContactInfo[1].publicInformation
                                  ? contactData.addressContactInfo[1].publicInformation
                                  : 'No data found'}
                                {/* {data.userEnteredInformation || data.publicInformation || 'No data found'} */}
                              </Box>
                            </Box>
                            <Box>
                              <Box color="#0A78CD" fontSize="12px" fontWeight={400}>
                                Zip Code
                              </Box>
                              <Box marginTop="5px" fontSize="16px" fontWeight={400} color="#66668F">
                                {contactData.addressContactInfo[2].publicInformation
                                  ? contactData.addressContactInfo[2].publicInformation
                                  : 'No data found'}
                                {/* {data.userEnteredInformation || data.publicInformation || 'No data found'} */}
                              </Box>
                            </Box>
                          </Box>
                        ) : (
                          <Box display="flex" gap="10px">
                            <TextField
                              label="City"
                              sx={sx.textBox}
                              maxRows={4}
                              variant="outlined"
                              InputLabelProps={{ shrink: false }}
                              className="customInput bootstrapLabel customLabel"
                              size="small"
                              fullWidth
                              defaultValue={
                                contactData.addressContactInfo[3].isCorrect === false &&
                                contactData.addressContactInfo[3].isDataChanged
                                  ? ''
                                  : contactData.addressContactInfo[0].userEnteredInformation
                              }
                              placeholder="No data found"
                              onChange={e =>
                                handleContaInfo(
                                  {
                                    ...contactData.addressContactInfo[0],
                                    userEnteredInformation: e.target.value,
                                    isMatched: contactData.addressContactInfo[0].publicInformation === e.target.value,
                                    isDataChanged: true,
                                  },
                                  'addressContactInfo',
                                )
                              }
                            />
                            <TextField
                              label="State"
                              sx={sx.textBox}
                              maxRows={4}
                              variant="outlined"
                              InputLabelProps={{ shrink: false }}
                              className="customInput bootstrapLabel customLabel"
                              size="small"
                              fullWidth
                              defaultValue={
                                contactData.addressContactInfo[3].isCorrect === false &&
                                contactData.addressContactInfo[3].isDataChanged
                                  ? ''
                                  : contactData.addressContactInfo[1].userEnteredInformation
                              }
                              placeholder="No data found"
                              onChange={e =>
                                handleContaInfo(
                                  {
                                    ...contactData.addressContactInfo[1],
                                    userEnteredInformation: e.target.value,
                                    isMatched: contactData.addressContactInfo[1].publicInformation === e.target.value,
                                    isDataChanged: true,
                                  },
                                  'addressContactInfo',
                                )
                              }
                            />
                            <TextField
                              label="Zip Code"
                              sx={sx.textBox}
                              maxRows={4}
                              variant="outlined"
                              InputLabelProps={{ shrink: false }}
                              className="customInput bootstrapLabel customLabel"
                              size="small"
                              fullWidth
                              defaultValue={
                                contactData.addressContactInfo[3].isCorrect === false &&
                                contactData.addressContactInfo[3].isDataChanged
                                  ? ''
                                  : contactData.addressContactInfo[2].userEnteredInformation
                              }
                              placeholder="No data found"
                              onChange={e =>
                                handleContaInfo(
                                  {
                                    ...contactData.addressContactInfo[2],
                                    userEnteredInformation: e.target.value,
                                    isMatched: contactData.addressContactInfo[2].publicInformation === e.target.value,
                                    isDataChanged: true,
                                  },
                                  'addressContactInfo',
                                )
                              }
                            />
                          </Box>
                        )}
                      </TableCell>
                      <TableCell align="center">
                        <Tooltip
                          onClick={() => (!open ? setOpen(true) : setOpen(false))}
                          onBlur={e => setOpen(false)}
                          arrow
                          componentsProps={{ tooltip: { sx: sx.tooltip }, arrow: { sx: sx.arrow } }}
                          title={
                            <Typography variant="body2">
                              The location that this business resides in. This could include any structure or department
                              that conducts business on behalf of your company, however, business owners are not
                              required to live in the state their business is registered in.
                            </Typography>
                          }
                          open={open}
                        >
                          <IconButton>
                            <InfoOutlinedIcon fontSize="large" sx={{ color: '#0099FF' }} />
                          </IconButton>
                        </Tooltip>
                      </TableCell>
                      <TableCell align="center">
                        {contactData.addressContactInfo[3].isCorrect !== null ? (
                          <Badge
                            type={
                              contactData.addressContactInfo[3].isCorrect === true
                                ? 'success'
                                : contactData.addressContactInfo[3].isCorrect === false &&
                                  contactData.addressContactInfo[3].isMatched === true
                                ? 'success'
                                : contactData.addressContactInfo[3].isCorrect === false &&
                                  contactData.addressContactInfo[3].isMatched === false &&
                                  'error'
                            }
                          />
                        ) : (
                          ''
                        )}
                      </TableCell>
                      <TableCell align="left">
                        {contactData.addressContactInfo[3].isCorrect !== null &&
                          contactData.addressContactInfo[3].updatedOn && (
                            <Box>
                              Updated on <br />
                              {contactData.addressContactInfo[3]
                                ? moment(contactData.addressContactInfo[3].updatedOn).format('MM/DD/YYYY')
                                : ''}
                            </Box>
                          )}
                      </TableCell>
                    </TableRow>
                  }
                  {contactData.primaryContactInfo.map(val => {
                    if (val.label !== 'PRIMARY_PHONE' && val.label !== 'PRIMARY_EMAIL') {
                      return (
                        <TableRow
                          key={val.label}
                          sx={{
                            'td, th': { border: 0 },
                            background:
                              val.isCorrect === true ? '#F6FCFA' : val.isCorrect === false ? '#FDF6F6' : '#fff',
                          }}
                        >
                          <TableCell component="th" scope="row">
                            <Box>
                              <Box color="#0A78CD" fontSize="12px" fontWeight={400}>
                                {findLabel(val.label)}
                              </Box>
                              <Box
                                marginTop="5px"
                                fontSize="16px"
                                fontWeight={400}
                                color={val.publicInformation ? '#66668F' : '#BDBDCE'}
                              >
                                {val.publicInformation ? val.publicInformation : 'No data found'}
                              </Box>
                            </Box>
                          </TableCell>
                          <SelectionBox
                            data={val}
                            TooltipContent={findTooltipContent(val.label)}
                            onDataChange={changedData => handleContaInfo(changedData, 'primaryContactInfo')}
                          />
                          <TableCell align="center">
                            {val.isCorrect !== null && (
                              <Badge
                                type={
                                  val.isCorrect === true
                                    ? 'success'
                                    : val.publicInformation === val.userEnteredInformation
                                    ? 'success'
                                    : val.isCorrect === false && val.isMatched
                                    ? 'success'
                                    : val.isCorrect === false && !val.isMatched && 'error'
                                }
                              />
                            )}
                          </TableCell>
                          <TableCell align="left">
                            {val.updatedOn && (
                              <Box>
                                Updated on <br />
                                {moment(val.updatedOn).format('MM/DD/YYYY')}
                              </Box>
                            )}
                          </TableCell>
                        </TableRow>
                      )
                    } else {
                      return null
                    }
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
          <ZendeskLink />
          {snackData.isOpen && <Snackbar isOpen={true} type={snackData.type} message={snackData.message} />}
        </Box>
      ) : (
        <Box display="flex" justifyContent="center" alignItems="center" height="50vh">
          <ThreeDotsLoadingSpinner width="60px" />
        </Box>
      )}
    </>
  )
}

export default ContactInformation;